import { __decorate } from "tslib";
import { injectable } from '@slickdeals/durango/dist/javascript/decorators/injectable';
import Logger from '@slickdeals/durango/dist/javascript/utilities/logger';
/** The name of the module */
export const name = 'Blueshift';
/** Recursion limit for timeout used to wait for window.blueshift to be available */
const TIMEOUT_DEPTH_LIMIT = 1500;
let Blueshift = class Blueshift {
    /**
       * Returns promise that resolves when the window.blueshift object becomes available
       *
       * @param depth Used to limit recursion depth
       */
    // TODO: Switch from using 100% Promises to async/await after switching from Encore to pure Webpack
    ready(depth = 0) {
        return new Promise((resolve, reject) => {
            // If the window.blueshift object is still undefined, then wait and try again
            if (typeof window.blueshift === 'undefined') {
                // Make sure we don't keep checking infinitely
                if (depth > TIMEOUT_DEPTH_LIMIT) {
                    reject(new Error('Max recursion reached attempting to load Blueshift API'));
                }
                else {
                    window.setTimeout(() => {
                        this.ready(depth + 1).then(() => {
                            resolve();
                        });
                    });
                }
            }
            else {
                // Save reference to global object
                this.blueshift = window.blueshift;
                resolve();
            }
        });
    }
    /**
       * Send a call to the Blueshift API's track() function
       *
       * @param eventName Name of the event to be tracked
       * @param data Custom data to track along with the event name
       */
    track(eventName, data) {
        return new Promise(resolve => {
            // Wait until the Blueshift API is available
            this.ready()
                .then(() => {
                this.blueshift.track(eventName, data);
                resolve();
            })
                .catch((error) => {
                Logger.error(`Blueshift .track() failed with error message: "${error}"`);
            });
        });
    }
};
Blueshift = __decorate([
    injectable(name)
], Blueshift);
export default Blueshift;
